import React, { useEffect, useState } from "react";
import API from "../api/api";
import "./AboutSection.css";

export default function AboutSection() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const res = await API.get("/about");
    setAbout(res.data.data);
  };

  if (!about) return null;

  return (
    <div className="about-home-section">
      <h2 className="text-center about-title">About Us</h2>

      <p className="main-description">{about.mainDescription}</p>

      <div className="about-sections">
        {about.sections.map((sec, i) => (
          <div key={i} className="about-box">
            <div className="heading-row">
              <span className="about-star">★</span>
              <h4>{sec.heading}</h4>
            </div>
            <p>{sec.description}</p>
          </div>
        ))}
      </div>

    </div>
  );
}
